import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import "./rentalSummaryDetails.scss";
import Button from "../command/Button/Button";
import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentCardModal from "./paymentCardModal";
import CustomFieldsModal from "../informationCaptureCard/customFieldsModal";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import MainTitle from "../command/mainTitle/mainTitle";
import { Link } from "react-router-dom";
import { Info, Edit2 } from "react-feather";
import { Effect } from "../../assets/svgIcon/customIcon";
import { orderClient } from "../../data/order";
import { getAuthCredentials, setQuoteCookies } from "../../utils/auth-utils";
import { DateTimeDisplay } from "../command/dateTime/formatDateTime";
import { FormattedDateRange } from "../command/dateTime/formatDateRange";
import { calculateDuration, isSameDate } from "../../utils/utils";
import { productDetailsClient } from "../../data/product-details";
import LoaderPage from "../command/loader/loader";
import { useTranslation } from "react-i18next";
import PaymentForm from "./paymentForm";
import PaymentModal from "./paymentModel";
import { customerVerificationClient } from "../../data/verify-info";
import ToastMessage from "../command/toast/toastMessage";
import SiteCookiesModal from "../command/siteCookiesModal/siteCookiesModal";
import { NotFound } from "../../pages";
import { toast } from "react-toastify";
import moment from "moment";
import { StoreDetails } from "../../interfaces/quote.interface";
import { QuoteCustomFieldValue } from "../../interfaces/quote.interface";
// import CompleteOrderModal from "./completeOrderModal";

interface charges {
  deliveryCharge: number;
  instoreCollectionCharge: number;
  depositCharge: number;
  serviceCharge: number;
}

interface product {
  productName: string;
  productRate: string;
  duration: string;
  rentalTerm?: any;
}

interface OwnItPricing {
  discountPercentage: number;
  purchasePrice: number;
  // Add other ownItPricing properties if needed
}

interface quoteCustomFieldValue {
  uuid: string;
  quoteUuid: string;
  fieldKey: string;
  fieldLabel: string;
  fieldValue: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

interface quote {
  uuid?: string;
  orderAmount: number;
  serviceCharge: number;
  deliveryCharge: number;
  retailerUuid: string;
  storeUuid: string;
  totalDepositAmount: number;
  deliveryMethod: string;
  deliveryAndCollectionCharge: number;
  totalQuoteValue?: number;
  instoreCollectionCharge?: number;
  rentalType: string;
  canConvertedToPurchaseAfterRent?: boolean;
  ownItPricing?: OwnItPricing;
  discountCode?: string;
  discountAmount?: number;
  isPaymentRequired?: boolean;
  showAddDiscountButton?: boolean;
  customerUuid?: string;
  isCreatedByRetailer?: boolean;
}
const RentalSummaryDetails = () => {
  const [paymentCardModalShow, setPaymentCardModalShow] = useState(false);
  const [data, setData] = useState<any>();
  const [cardDetailsList, setCardDetailsList] = useState<any>([]);
  const [error, setError] = useState<string | null>(null);
  const [apiRetryError, setApiRetryError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [isChecked, setIsChecked] = useState(false);
  const [totalAmount, setTotalAmount] = useState<any>(0);
  const [searchParams] = useSearchParams();
  const orderFromUrl = searchParams.get('order');
  const tokenFromUrl = searchParams.get('token') || undefined;
  const [cookiesConsent, setCookiesConsent] = useState(Cookies.get("cookiesConsent"));
  const [cookiesModalShow, setCookiesModalShow] = useState(false);
  const [cookieDeclineAttempts, setCookieDeclineAttempts] = useState(0);
  const [customerDetailsFromQuote, setCustomerDetailsFromQuote] = useState<any>(null);
  const { customerUuid, quoteId: cookieQuoteId, userUuid: cookieUserUuid, token: cookieToken } = getAuthCredentials();
  const quoteId = orderFromUrl ?? cookieQuoteId;
  // Guest/magic-link visitors (arrived via ?order=&token=) never get an auth
  // cookie written, so their user identity only ever lives in the quote response.
  const userUuid = cookieUserUuid || customerDetailsFromQuote?.userUuid;
  // update-customer-quote is an OPEN_API endpoint, so it only ever gets a token
  // when we explicitly pass one as _urlToken. Prefer the guest URL token; fall
  // back to the logged-in user's cookie token when there's no URL token.
  const customerQuoteToken = tokenFromUrl || cookieToken;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [quote, setQuote] = useState<quote>();
  const [storeDetails, setStoreDetails] = useState<StoreDetails | null>(null);
  const [quoteCustomFieldValues, setQuoteCustomFieldValues] = useState<QuoteCustomFieldValue[]>([]);
  const [customerInfo, setCustomerInfo] = useState(false);
  const [sessionId, setSessionId] = useState<any>();
  const [showCustomFieldsModal, setShowCustomFieldsModal] = useState(false);
  const [customFields, setCustomFields] = useState<any[]>([]);
  const [isUpdatingCustomFields, setIsUpdatingCustomFields] = useState(false);
  const [showPromocode, setShowPromocode] = useState(false);
  const [promocodeInput, setPromocodeInput] = useState("");
  const [appliedPromocode, setAppliedPromocode] = useState<string | null>(null);
  const [discountError, setDiscountError] = useState(false);
  const [openDiscountSection, setOpenDiscountSection] = useState(false);
  const [isProductAvailable, setIsProductAvailable] = useState<boolean | null>(null);
  // const [showCompleteOrderModal, setShowCompleteOrderModal] = useState(false);
  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!cookiesConsent) {
      setCookiesModalShow(true);
    } else if (cookiesConsent === "rejected") {
      setCookiesModalShow(true);
    }
  }, [cookiesConsent]);

  const handleCookieConsent = (consent: string) => {
    Cookies.set("cookiesConsent", consent, { expires: 365 });
    setCookiesConsent(consent);
    setCookiesModalShow(false);
  };

  // Cookie acceptance is mandatory here (order/token can't be persisted without it).
  // Re-prompt twice on dismissal without a decision; after the third attempt, stop
  // asking and leave the page in whatever state it's already in.
  const handleCookieModalDismiss = () => {
    if (cookieDeclineAttempts >= 2) {
      setCookiesModalShow(false);
      return;
    }
    setCookieDeclineAttempts((prev) => prev + 1);
    toast.error("Cookie acceptance is required to continue.");
  };

  // This link is the authoritative reference for a specific order, so unlike the cart's
  // deep-link handling, it always overwrites the existing quote cookie rather than only
  // filling in what's missing.
  useEffect(() => {
    if (cookiesConsent !== "isAccepted") return;
    if (!orderFromUrl) return;
    setQuoteCookies(orderFromUrl);
  }, [orderFromUrl, cookiesConsent]);

  // Guest/magic-link visitors are never logged in via cookie — `tokenFromUrl` stays
  // in the URL for the whole visit and gets passed explicitly to each API call that
  // needs it (see `_urlToken` handling in http-client.ts) instead of being persisted.

  // Handle checkbox change
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
    const request = {
      retailerUuid: quote?.retailerUuid,
      storeUuid: quote?.storeUuid,
      quoteUuid: quoteId,
      customerUuid: orderFromUrl ? quote?.customerUuid : userUuid,
      termsAndConditionsAccepted: e.target.checked, // This value will be used when user click on view TNC page or click to accept TNC
    };
    productDetailsClient
      .getTermsConditions(request, tokenFromUrl)
      .then((data: any) => { })
      .catch((error: any) => {
        toast.error(error?.message);
      });
  };


  const fetchQuoteDetails = async (quoteId: string, fromPromocode?: boolean) => {
    try {
      !fromPromocode && setLoading(true);
      const data: any = await productDetailsClient.getProductDetailsList({
        quoteUuid: quoteId,
      });

      // Manipulate data.products to separate rows for multiple quantity
      const unwrappedProducts = data.products.flatMap((product: any) =>
        Array.from({ length: product.productQuantity }, () => ({
          ...product,
          productQuantity: 1,
        }))
      );

      setData(unwrappedProducts);
      setQuote(data.quote);
      if (data.customerDetails) {
        setCustomerDetailsFromQuote(data.customerDetails);
      }

      if (orderFromUrl && data.quote?.isCreatedByRetailer === false) {
        setError("Looks like something went wrong, please try again later!");
        return;
      }

      if (orderFromUrl && data.quote?.orderReferenceId !== null) {
        setError("Looks like something went wrong, please try again later!");
        return;
      }

      setStoreDetails(data.storeDetails);
      if (data?.quote?.discountCode) {
        setAppliedPromocode(data.quote.discountCode);
      }

      if (data.quoteCustomFieldValues) {
        setQuoteCustomFieldValues(data.quoteCustomFieldValues);
      }

      if (data.storeCustomFields) {
        setCustomFields(data.storeCustomFields);
      }

      // Check product availability after fetching quote details
      await checkProductAvailability(data.products, data.quote);
    } catch (error: any) {
      toast.error("Please contact Renticy Support via live chat or via the Help Centre.");
      setApiRetryError(true);
    } finally {
      setLoading(false);
    }
  };

  const checkProductAvailability = async (products: any[], quoteData: any) => {
    if (!products || products.length === 0 || !quoteData) return;

    const mapRentalType = (type: string) => {
      if (type === "day" || type === "daily") return "daily";
      if (type === "monthly") return "monthly";
      if (type === "monthly-recurring") return "monthly-recurring";
      return "hourly";
    };

    const request = {
      products: products.map((product: any) => ({
        productUuid: product.productUuid,
        retailerUuid: product.retailerUuid,
        storeUuid: product.storeUuid,
        rentalDuration: product.rentalTerm,
        quantity: product.productQuantity || 1,
        rentalType: mapRentalType(quoteData.rentalType),
        bookingDate: {
          bookingStartDate: product.productBookingStartDate,
          bookingEndDate: product.productBookingEndDate,
        },
        productVariantUuid: product.productVariantUuid,
        productRetailValue: product.productRetailValue,
      })),
    };

    try {
      const chargesData: any = await productDetailsClient.getQuotesCharges(request);
      setIsProductAvailable(chargesData?.productAvailibility ?? true);
    } catch (error) {
      // If the check fails, don't block the user — assume available
      setIsProductAvailable(true);
    }
  };

  useEffect(() => {
    if (quoteId) {
      fetchQuoteDetails(quoteId);
    }
  }, []);

  useEffect(() => {
    if (apiRetryError) {
      const timer = setTimeout(() => window.location.reload(), 5000);
      return () => clearTimeout(timer);
    }
  }, [apiRetryError]);

  useEffect(() => {
    const subtotal = data?.reduce(
      (total: any, order: any) => total + (parseFloat(order.productRate) || 0),
      0
    );
    if (quote) {
      calculateTotalPrice(quote.totalQuoteValue);
    }
  }, [data, quote]);

  // Must be defined before the early returns so the useEffect closure can always reach it
  const calculateTotalPrice = (subtotal: any) => {
    const isDeliveryOrder = quote?.deliveryMethod == "Delivery and Collection";
    const deliveryCharges = quote?.deliveryAndCollectionCharge;
    const serviceChargeValue = quote ? +quote.serviceCharge : 0;
    const totalAmount =
      Number(subtotal) +
      Number(serviceChargeValue) +
      (isDeliveryOrder ? Number(deliveryCharges) : 0);
    setTotalAmount(Number(totalAmount).toFixed(2));
  };

  if (loading) {
    return <LoaderPage />;
  }

  if (error) {
    return <NotFound errorText={error} />;
  }

  if (apiRetryError) {
    return <LoaderPage />;
  }

  const handlePayNow = async () => {
    const effectiveCustomerUuid = quote?.isCreatedByRetailer ? quote?.customerUuid : userUuid;
    setLoading(true);
    await customerVerificationClient
      .getCustomerInfo({ uuid: effectiveCustomerUuid }, tokenFromUrl)
      .then((respnse: any) => {
        console.log("Customer Info: ", respnse);
        setCustomerInfo(respnse);
      })
      .catch((error: any) => {
        toast.error("Please contact Renticy Support via live chat or via the Help Centre.");
        setApiRetryError(true);
        setLoading(false);
      });
    orderClient
      .paymentInitiate({ uuid: effectiveCustomerUuid, quoteId: quoteId }, tokenFromUrl)
      .then((res: any) => {
        if (!res.session_id && res.isPaymentRequired === false) {
          orderClient
            .checkoutOrder({ customerUUID: userUuid, quoteUUID: quoteId, paymentUUID: null }, tokenFromUrl)
            .then((checkoutRes: any) => {
              navigate(`/congratulations?orderId=${checkoutRes.quoteUuid}&status=success`);
              setLoading(false);
            })
            .catch((checkoutError: any) => {
              toast.error("Something went wrong.");
              console.error("Checkout Error:", checkoutError);
              setLoading(false);
            });
        } else {
          setPaymentCardModalShow(true);
          setSessionId(res.session_id);
          setCardDetailsList(res.cardLists);
          setLoading(false);
        }

      })
      .catch((error: any) => {
        toast.error("Please contact Renticy Support via live chat or via the Help Centre.");
        setApiRetryError(true);
        setLoading(false);
      });
  };

  const handleCustomFieldsUpdate = (values: any) => {
    setIsUpdatingCustomFields(true);

    const quoteCustomFieldValuesPayload = Object.keys(values).map((fieldKey) => {
      const field = customFields.find((f) => f.fieldKey === fieldKey);
      const existingField = quoteCustomFieldValues.find((f) => f.fieldKey === fieldKey);

      const fieldData: any = {
        fieldKey: fieldKey,
        fieldLabel: field?.label || fieldKey,
        fieldValue: values[fieldKey],
      };

      if (existingField?.uuid) {
        fieldData.uuid = existingField.uuid;
      }

      return fieldData;
    });

    const request = {
      customerQuoteUuid: quote?.uuid || quoteId,
      quoteCustomFieldValues: quoteCustomFieldValuesPayload,
    };

    productDetailsClient
      .updateCustomerQuote(request, customerQuoteToken)
      .then((response: any) => {
        setIsUpdatingCustomFields(false);
        setShowCustomFieldsModal(false);
        toast.success("Additional Information Updated Successfully");

        productDetailsClient
          .getProductDetailsList({ quoteUuid: quoteId })
          .then((data: any) => {
            if (data.quoteCustomFieldValues) {
              setQuoteCustomFieldValues(data.quoteCustomFieldValues);
            }
          })
          .catch((error: any) => {
            toast.error(error?.message);
          });
      })
      .catch((error: any) => {
        setIsUpdatingCustomFields(false);
        toast.error(error?.message || "Failed to update additional information");
      });
  };

  const handleApplyPromocode = () => {
    setDiscountError(false);
    if (promocodeInput.trim()) {
      productDetailsClient
        .applyPromoCode({ discountCode: promocodeInput, quoteUuid: quoteId, customerUuid: userUuid }, tokenFromUrl)
        .then((response: any) => {
          setAppliedPromocode(promocodeInput);
          setShowPromocode(false);
          toast.success(`Discount code "${promocodeInput}" applied successfully`);
          if (quoteId) {
            fetchQuoteDetails(quoteId, true);
          }
        })
        .catch((error: any) => {
          setDiscountError(true);
          // toast.error("Invalid discount code");
        });
    }
  };

  const handleRemovePromocode = () => {
    if (appliedPromocode) {
      productDetailsClient
        .removePromoCode({ discountCode: appliedPromocode, quoteUuid: quoteId, customerUuid: userUuid }, tokenFromUrl)
        .then((response: any) => {
          setAppliedPromocode("");
          setPromocodeInput("");
          setShowPromocode(false);
          setOpenDiscountSection(true);
          toast.success(response?.message ? response.message : `Promocode "${appliedPromocode}" removed successfully`);
          if (quoteId) {
            fetchQuoteDetails(quoteId, true);
          }
        })
        .catch((error: any) => {
          toast.error("Failed to remove promocode");
        });
    }
  };

  return (
    <>
      <section className="cart-section section-space rental-summary-details">
        <div className={windowWidth < 768 ? "container-fluid" : "container"}>
          <div className="row">
            <div className="offset-xxl-0 col-xxl-8 offset-xl-0 col-xl-7 offset-md-1 col-md-10">
              <MainTitle mainText={t("your-rental-summary")} />
              {isProductAvailable === false && (
                <div
                  className="product-unavailable-banner mb-3"
                  style={{
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffc107",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    color: "#856404",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  ⚠️ Some products in this order are no longer available for the selected dates. Please contact the store.
                </div>
              )}
            </div>
            <div className="offset-xxl-0 col-xxl-8 offset-xl-0 col-xl-7 offset-md-1 col-md-10">
              {/*  */}
              <div className="cart-product-date">
                <h4 className="estimated-date">
                  {t("estimated-dates")}
                  <OverlayTrigger
                    placement="auto"
                    overlay={
                      <Tooltip
                        id={`tooltip-e-date`}
                        style={{ position: "fixed" }}
                      >
                        {t("estimated-dates-tooltip")}
                      </Tooltip>
                    }
                    popperConfig={{
                      modifiers: [
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: "window", // Ensure the tooltip stays within the window boundary
                          },
                        },
                        {
                          name: "flip",
                          options: {
                            fallbackPlacements: [
                              "top",
                              "bottom",
                              "left",
                              "right",
                            ], // Provide fallback placements
                          },
                        },
                      ],
                    }}
                  >
                    <Info className="info-icon" />
                  </OverlayTrigger>
                </h4>
                {/* {data?.map((item: any, index: number) => ( */}
                <div className="selected-date">
                  <div className="selected-date-box">
                    <h5 className="product-date">
                      {isSameDate(
                        data[0]?.productBookingStartDate,
                        data[0]?.productBookingEndDate
                      ) && quote?.rentalType == 'hourly' ? (
                        <DateTimeDisplay
                          startDateTime={data[0]?.productBookingStartDate}
                          endDateTime={data[0]?.productBookingEndDate}
                        />
                      ) : (

                        quote?.rentalType === 'monthly-recurring' ? (
                          // Combine the formatted and 'Monthly Rolling'
                          `${moment(data[0]?.productBookingStartDate).format('DD MMMM')} – Monthly rolling`
                        ) : (
                          // For other rental types, just display the formatted date
                          <FormattedDateRange
                            startDate={data[0]?.productBookingStartDate}
                            endDate={data[0]?.productBookingEndDate}
                          />
                        )
                      )}
                    </h5>
                    {isSameDate(
                      data[0]?.productBookingStartDate,
                      data[0]?.productBookingEndDate
                    ) && quote?.rentalType == 'hourly' ? (
                      <span className="date-duration">
                        {t("duration")} :{" "}
                        {calculateDuration(
                          data[0]?.productBookingStartDate,
                          data[0]?.productBookingEndDate,
                          quote?.rentalType,
                          data[0]?.rentalTerm
                        )}
                      </span>
                    ) : (
                      <span className="date-duration">
                        {t("duration")} : {quote?.rentalType === 'monthly-recurring' ? '' : data[0]?.rentalTerm} {" "}
                        {quote?.rentalType === 'monthly-recurring' ? t("flexible") : ''}
                        {quote?.rentalType === 'monthly' ? data[0]?.rentalTerm > 1 ? t("months") : t("month") : ''}
                        {quote?.rentalType === 'daily' ? data[0]?.rentalTerm > 1 ? t("days") : t("day") : ''}
                      </span>
                    )}
                  </div>
                </div>
                {/* ))} */}
              </div>
              {/*  */}
              <div className="cart-product-section product-box-section">
                <div className="cart-product-title">
                  <h4>{t("products-details")}</h4>
                  <h4>{t("total")}</h4>
                </div>
                <div className={`cart-product-details-boxs`}>
                  {data &&
                    // Group products by productUuid, productVariantUuid, and rental value
                    Object.values(
                      data.reduce((acc: any, item: any) => {
                        // Create a unique key using productUuid and productVariantUuid
                        const key = `${item.productUuid}-${item.productVariantUuid}`;
                        if (!acc[key]) {
                          // If this is the first time seeing this product, initialize it with quantity 1
                          acc[key] = {
                            ...item,
                            quantity: 1,
                            // Store the original items for reference
                            originalItems: [item]
                          };
                        } else {
                          // If we've seen this product before, increment the quantity
                          acc[key].quantity += 1;
                          acc[key].originalItems.push(item);
                        }
                        return acc;
                      }, {})
                    ).map((item: any, index: number) => (
                      <div
                        className="cart-product-details rental-summary-price"
                        key={`${item.productUuid}-${item.productVariantUuid}-${index}`}
                      >
                        <div className="product-info">
                          <h4 className="c-product-title">
                            {item.quantity} × {item.productName}
                          </h4>

                          {/* Display variant options if they exist */}
                          {(item.option1 || item.option2 || item.option3) && (
                            <div className="variant-options">
                              <p className="variant-option">
                                {item.option1 && (
                                  <span className="option">
                                    {item.option1.includes(': ')
                                      ? <><span className="option-label">{item.option1.split(': ')[0]}:</span> {item.option1.split(': ')[1]}</>
                                      : item.option1}
                                  </span>
                                )}
                                {item.option2 && (
                                  <span className="option">
                                    {item.option2.includes(': ')
                                      ? <><span className="option-label">{item.option2.split(': ')[0]}:</span> {item.option2.split(': ')[1]}</>
                                      : item.option2}
                                  </span>
                                )}
                                {item.option3 && (
                                  <span className="option">
                                    {item.option3.includes(': ')
                                      ? <><span className="option-label">{item.option3.split(': ')[0]}:</span> {item.option3.split(': ')[1]}</>
                                      : item.option3}
                                  </span>
                                )}
                              </p>
                            </div>
                          )}
                        </div>

                        <h5 className="product-price">
                          £{(Number(item.productRentalValue) * (item.quantity || 1)).toFixed(2)}
                          {
                            quote?.rentalType === "monthly" &&
                            <> per month</>
                          }
                        </h5>
                      </div>
                    ))}
                </div>
              </div>
              {/* Additional Information Section */}
              {quoteCustomFieldValues && quoteCustomFieldValues.length > 0 && (
                <div className="additional-information mt-4 cart-product-section product-box-section">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="section-title mb-0">Additional Information</h4>
                    <button
                      className="btn d-flex align-items-center gap-1"
                      onClick={() => setShowCustomFieldsModal(true)}
                      style={{
                        color: '#00A8A8',
                        backgroundColor: '#E6F7F7',
                        border: '1px solid #00A8A8',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#00A8A8';
                        e.currentTarget.style.color = '#FFFFFF';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#E6F7F7';
                        e.currentTarget.style.color = '#00A8A8';
                      }}
                    >
                      Edit
                    </button>
                  </div>
                  {quoteCustomFieldValues.map((field) => (
                    <div key={field.uuid} className="mb-2 ai-info-col">
                      <label className="label-additional-text">{field.fieldLabel}:</label>
                      <div className="additional-info-text">{field.fieldValue ? field.fieldValue : "N/A"}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/*  */}

            {/*  */}
            <div className="offset-xxl-0 col-xxl-4 offset-xl-0 col-xl-5 offset-md-1 col-md-10">
              <div className="order-summary-position">
                <div className="effect-add-section cart-page-effect">
                  <Effect className="effect-img" />
                  {/*  */}
                  <div className="cart-product-section delivery-section">
                    <div className="cart-product-title order-summary">
                      <h4>{t("order-summary")}</h4>
                    </div>
                    <div className="delivery-method">
                      {/* Delivery method title */}
                      {/* <h4>Delivery Method</h4> */}
                      <div className="select-method">
                        {quote?.deliveryMethod === "Collect from Store" ? (
                          <div className="cart-value">
                            <h5 className="cart-title">
                              {t("collect-in-store")}
                            </h5>
                            <h5 className="product-price">
                              £
                              {Number(
                                quote?.instoreCollectionCharge ?? 0
                              ).toFixed(2)}
                            </h5>
                          </div>
                        ) : (
                          <div className="cart-value">
                            <h5 className="cart-title">
                              {t("delivery-and-collection")}
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip
                                    id={`tooltip-dc`}
                                    style={{ position: "fixed" }}
                                  >
                                    {t("delivery-and-collection-tooltip")}
                                  </Tooltip>
                                }
                              >
                                <Info size={18} className="info-icon ms-2" />
                              </OverlayTrigger>
                            </h5>
                            <h5 className="product-price">
                              £
                              {Number(
                                quote?.deliveryAndCollectionCharge ?? 0
                              ).toFixed(2)}
                            </h5>
                          </div>
                        )}

                        <div className="cart-value">
                          {!quote?.canConvertedToPurchaseAfterRent && (
                            <>
                              <h5 className="cart-title">
                                Renticy {t("renticy-service-charge")}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-service`}
                                      style={{ position: "fixed" }}
                                    >
                                      <div dangerouslySetInnerHTML={{ __html: t("renticy-service-charge-tooltip") }} />
                                    </Tooltip>
                                  }
                                >
                                  <Info className="info-icon ms-2" size={18} />
                                </OverlayTrigger>
                              </h5>
                              <h5 className="product-price">
                                £{Number(quote?.serviceCharge ?? 0).toFixed(2)}
                                {
                                  quote?.rentalType === "monthly" &&
                                  <> per month</>
                                }
                              </h5>
                            </>
                          )}
                        </div>

                        {/* Discount Applied Section - Only show when discount exists */}
                        {quote?.discountAmount && quote?.discountAmount > 0 && (
                          <div className="cart-value">
                            <h5 className="cart-title">Discount Applied</h5>
                            <h5 className="product-price">
                              - £{Number(quote?.discountAmount).toFixed(2)}
                            </h5>
                          </div>
                        )}
                        <div className="divider-top cart-value total-cart">
                          <h5 className="cart-title">
                            {quote?.canConvertedToPurchaseAfterRent ? t("total-trial-to-pay-today") : t("total-rental-to-pay-today")}
                          </h5>
                          <h5 className="product-price cart-price">
                            £{totalAmount}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="cart-product-section refundable-deposit">
                    <div className="refundable-title">
                      <img
                        src="/icons/deposit.svg"
                        alt=""
                        className="me-2 img-fluid info-icon"
                      />
                      <h5 className="cart-title">
                        {t("refundable-deposit")}
                        <span>
                          {t("what-is-this")}
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip
                                id={`tooltip-rd`}
                                style={{ position: "fixed" }}
                              >
                                {t("refundable-deposit-tooltip")}
                              </Tooltip>
                            }
                          >
                            <Info className="info-icon ms-1" size={18} />
                          </OverlayTrigger>
                        </span>
                      </h5>
                    </div>
                    <h5 className="product-price cart-price">
                      £{Number(quote?.totalDepositAmount ?? 0).toFixed(2)}
                    </h5>
                  </div>



                  {/* Promocode Section */}
                  <div className="cart-product-section promocode-section">
                    {(!loading && openDiscountSection || quote?.discountCode) && <>
                      {!appliedPromocode ? (
                        <></>
                        // (
                        //   <div className="promocode-input-wrapper">
                        //     <div className="promocode-header">
                        //       <h5>Add Discount code</h5>

                        //     </div>
                        //     <div className="promocode-input-group">

                        //       <input
                        //         type="text"
                        //         className="promocode-input"
                        //         placeholder="Enter discount code"
                        //         value={promocodeInput}
                        //         onChange={(e) => setPromocodeInput(e.target.value)}
                        //         onKeyPress={(e) => {
                        //           if (e.key === "Enter") {
                        //             handleApplyPromocode();
                        //           }
                        //         }}
                        //       />


                        //       <button
                        //         className="promocode-apply-btn"
                        //         onClick={handleApplyPromocode}
                        //         disabled={!promocodeInput.trim()}
                        //       >
                        //         Apply
                        //       </button>
                        //     </div>
                        //     {discountError && (
                        //       <>
                        //         <div className="promocode-error">Invalid Discount Code</div>
                        //       </>
                        //       // <div className="promocode-error">Invalid Discount Code</div>
                        //       // <Form.Control.Feedback type="invalid">Invalid Discount Code</Form.Control.Feedback>

                        //     )}
                        //   </div>
                        // )
                      ) : (
                        <div className="promocode-applied-wrapper">
                          <div className="promocode-applied-header">
                            <div className="applied-status">
                              <span className="checkmark">✓</span>
                              <span>Discount code Applied</span>
                            </div>
                            {/* <span
                              className="promocode-remove-btn"
                              onClick={handleRemovePromocode}
                            >
                              Remove
                            </span> */}
                          </div>
                          <div className="promo-code-display">{appliedPromocode}</div>
                        </div>
                      )}
                    </>
                      // :
                      //   quote?.showAddDiscountButton && (
                      //     <span
                      //       className="promocode-button"
                      //       onClick={() => setOpenDiscountSection(true)}
                      //     >
                      //       Apply Discount Code +
                      //     </span>
                      //   )
                    }
                  </div>

                  {/*  */}
                  {quote?.canConvertedToPurchaseAfterRent && (
                    <div className="ownit-box d-flex align-items-center justify-content-between mt-3">
                      <div>
                        <div className="ownit-text-black">OWN<span>it</span></div>
                        <label
                          htmlFor="optional-price-after-trial"
                          className="form-check-label"
                        >
                          {t("optional-price-after-trial")}
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-op`}>
                                <div dangerouslySetInnerHTML={{ __html: t("optional-price-after-trial-tooltip") }} />
                              </Tooltip>
                            }
                          >
                            <Info className="info-icon ms-2" size={18} />
                          </OverlayTrigger>
                        </label>
                      </div>
                      <div className="ownit-price-text text-end">
                        <div className="ownit-price">£{quote?.ownItPricing?.purchasePrice?.toFixed(2)}</div>
                        <div><span className="fw-bold">{quote?.ownItPricing?.discountPercentage}% off</span> retail price​</div>
                      </div>
                    </div>
                  )}


                  <div className="cart-product-section place-order-btn">
                    {storeDetails && storeDetails?.storeLink &&
                      <div className="cart-product-section store-link flex-none">
                        Please take time to read and understand the <a href={storeDetails?.storeLink} target="_blank" className="site-link">Safety advice</a>
                      </div>
                    }
                    {isProductAvailable !== false && (
                      <>
                        <Form.Check
                          type={"checkbox"}
                          id={`terms-conditions`}
                          name="termsConditions"
                          className="terms-checkbox mb-md-4 mb-3"
                          label={
                            <>
                              {t("terms-conditions.terms-conditions-one")}{" "}
                              <Link
                                to={{
                                  pathname: `/termsconditions`,
                                  search: orderFromUrl ? `?order=${orderFromUrl}&customer=${quote?.customerUuid ?? ''}${tokenFromUrl ? `&token=${tokenFromUrl}` : ''}` : undefined,
                                }}
                                className="site-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => {
                                  const data = {
                                    retailerUuid: quote?.retailerUuid,
                                    storeUuid: quote?.storeUuid,
                                  };
                                  localStorage.setItem(
                                    "data",
                                    JSON.stringify(data)
                                  );
                                }}
                              >
                                {t("terms-conditions.terms-conditions-two")}
                              </Link>{" "}
                              {t("terms-conditions.terms-conditions-three")}
                            </>
                          }
                          checked={isChecked}
                          disabled={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <Button
                          btnText={quote?.isPaymentRequired === false ? "Complete Booking" : `${t("proceed-to-pay")} £${(Number(totalAmount || 0) + Number(quote?.totalDepositAmount || 0)).toFixed(2)}`}
                          onClick={() => handlePayNow()}
                          disabled={!isChecked}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* {showPaymentForm && sessionId && <PaymentForm sessionId={sessionId} publicKey={publicKey} />} */}

      {/* <PaymentCardModal
        show={paymentCardModalShow}
        cardlist={cardDetailsList}
        orderdetails={quote}
        producttotalrate={totalAmount}
        sessionId={sessionId}
        publicKey={publicKey}
        onHide={() => setPaymentCardModalShow(false)}
      /> */}

      <PaymentModal
        show={paymentCardModalShow}
        cardlist={cardDetailsList}
        orderdetails={quote}
        producttotalrate={totalAmount}
        sessionid={sessionId}
        customerinfo={customerInfo}
        onHide={() => setPaymentCardModalShow(false)}
      />

      <CustomFieldsModal
        show={showCustomFieldsModal}
        onHide={() => setShowCustomFieldsModal(false)}
        onSubmit={handleCustomFieldsUpdate}
        customFields={customFields}
        existingValues={quoteCustomFieldValues}
        loading={isUpdatingCustomFields}
      />
      {/* <CompleteOrderModal
        show={showCompleteOrderModal}
        onHide={() => setShowCompleteOrderModal(false)}
        onConfirm={() => {
          setShowCompleteOrderModal(false);
          handlePayNow();
        }}
      /> */}

      {/* <ToastMessage
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
        type={toastType}
      /> */}

      {/* Cookies Modal */}
      <SiteCookiesModal
        show={cookiesModalShow}
        cookiesHide={handleCookieModalDismiss}
        onAccept={() => handleCookieConsent("isAccepted")}
        onReject={() => handleCookieConsent("rejected")}
        onSettings={() => handleCookieConsent("settings")}
      />
    </>
  );
};

export default RentalSummaryDetails;
